module.exports = __webpack_public_path__ + "static/media/plus.b1c5f78f.svg";